/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { DatePicker } from '@material-ui/pickers'
import { Select, MenuItem, FormControl } from '@material-ui/core'
import { KeyboardArrowDownRounded } from '@material-ui/icons'

import moment, { Moment } from 'config/moment'
import { CustomCheckbox } from 'components/CustomCheckbox'

import { Store } from './types'
import { montserratLightStyle, montserratStyle } from '../styles'

interface StoresAndDateFilterProps {
  // eslint-disable-next-line @typescript-eslint/member-delimiter-style
  period: { month: number; year: number }
  onPeriodChange: (date: Moment | null) => void
  storesList: Store[]
  store: string
  onStoreChange: (e: React.ChangeEvent<{ value: unknown }>) => void
  compara: boolean
  onComparaChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  compareStore: string
  onCompareStoreChange: (e: React.ChangeEvent<{ value: unknown }>) => void
  onApply: () => void
  allUsersFilter?: boolean
  recurrentUsersFilter?: boolean
  isLoading?: boolean
}

const StoresAndDateFilter: React.FC<StoresAndDateFilterProps> = ({
  period,
  onPeriodChange,
  storesList,
  store,
  onStoreChange,
  compara,
  onComparaChange,
  compareStore,
  onCompareStoreChange,
  onApply,
  allUsersFilter = false,
  recurrentUsersFilter = false,
  isLoading = false,
}) => {
  const activeStores = storesList.filter(storeItem => storeItem.deletedAt === null)

  // borrar si se vuelve a usar el compara
  const comparaDisabled = false

  return (
    <div className="flex flex-row items-end justify-between gap-8 w-full">
      <div className="flex flex-row items-end gap-8">
        <div>
          <DatePicker
            views={['month', 'year']}
            value={moment()
              .year(period.year)
              .month(period.month)}
            onChange={onPeriodChange}
            format="MMMM YYYY"
            InputProps={{
              disableUnderline: false,
              style: { fontSize: 18, color: '#6B7280', paddingLeft: 8, ...montserratStyle },
            }}
            InputLabelProps={{
              style: { color: '#6B7280', fontSize: 16, left: 8, ...montserratStyle },
            }}
            style={{ width: '200px', borderRadius: 8, ...montserratStyle }}
            maxDate={moment()}
          />
        </div>
        {/* <FormControl style={{ minWidth: 250 }}>
          <Select
            value={store}
            onChange={onStoreChange}
            style={{ ...montserratStyle }}
            IconComponent={KeyboardArrowDownRounded}
          >
            <MenuItem value="all">Todos los locales</MenuItem>
            {activeStores.map(storeItem => (
              <MenuItem key={storeItem.id} value={storeItem.name}>
                {storeItem.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className="flex items-center mb-2 gap-2">
          <CustomCheckbox
            checked={comparaDisabled}
            onChange={onComparaChange}
            className="w-4 h-4 rounded border border-gray-400"
          />
          <span className="text-s" style={{ ...montserratStyle }}>
            Comparar con
          </span>
        </div>
        <FormControl style={{ minWidth: 250 }}>
          <Select
            value={compareStore}
            onChange={onCompareStoreChange}
            disabled={!comparaDisabled}
            style={{ ...montserratStyle }}
            IconComponent={KeyboardArrowDownRounded}
          >
            <MenuItem value="all">Todos los locales</MenuItem>
            {activeStores.map(storeItem => (
              <MenuItem key={storeItem.id} value={storeItem.name}>
                {storeItem.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        {allUsersFilter && (
          <label className="flex items-center mb-2 gap-2 text-s " style={{ ...montserratStyle }}>
            <CustomCheckbox className="w-4 h-4 rounded border border-gray-400" />
            Todos los usuarios
          </label>
        )}
        {recurrentUsersFilter && (
          <label className="flex items-center mb-2 gap-2 text-s " style={{ ...montserratStyle }}>
            <CustomCheckbox className="w-4 h-4 rounded border border-gray-400" />
            Usuarios recurrentes
          </label>
        )}
      </div>
      <button
        type="button"
        className={`rounded px-6 py-2 font-semibold ${
          isLoading
            ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
            : 'bg-[#26342E] text-white hover:bg-[#1a2a24]'
        }`}
        onClick={onApply}
        disabled={isLoading}
        style={{ ...montserratLightStyle }}
      >
        {isLoading ? 'Cargando...' : 'Aplicar'}
      </button>
    </div>
  )
}

StoresAndDateFilter.defaultProps = {
  allUsersFilter: false,
  recurrentUsersFilter: false,
  isLoading: false,
}

export default StoresAndDateFilter
